import Button from "@mui/material/Button";

function CopyInstructionsButton() {
  return (
    <div style={{ marginTop: 20 }}>
      <Button variant="contained" style={{ minWidth: 150 }}>
        Copy Instructions
      </Button>
    </div>
  );
}

export default CopyInstructionsButton;
